import { cardImageSources, type GenericCharacter } from './types'

export const genericVampiro: GenericCharacter = {
  id: 'generic-vampiro',
  enabled: true,
  order: 16,
  displayName: 'Vlad',
  icon: '🧛',
  imageSources: cardImageSources('generic-vampiro'),
}
